<template>
  <div class="home">
    <div class="home__user-data">
      <h4 class="home__user-data__login home__user-data__text">
        <font-awesome-icon :icon="['fas', 'key']" /> {{ store.getData('user').login }}
      </h4>
      <h4 class="home__user-data__name home__user-data__text">
        <font-awesome-icon :icon="['fas', 'user']" /> {{ computedName }}
      </h4>
    </div>
  </div>
</template>

<script>
/* Mixins */
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

/* ------ */
export default
{
  name: 'Home',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  mixins: [SocketHandler, LifeCycle],
  props:
  {
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  computed: {
    computedName() {
      const user = this.store.getData('user')
      return `${user.first_name} ${user.last_name}`
    }
  }
}
</script>

<style lang="scss">
.home {
  position: relative;

  &__user-data {
    position: absolute;
    top: 0;
    right: 0;
    text-align: right;
    margin-top: 20px;

    &__text {
      margin: 10px 20px;
      color: $color-grey;
    }
  }
}
</style>
